export default class ReadMoreToggle {
	constructor({ elements }) {
		elements.forEach((el) => {
			el.addEventListener('click', () => {
				ReadMoreToggle.toggleFading(el);
			});
		});
	}

	static toggleFading(el) {
		const element = el;
		const fadingElement = document.getElementById(el.dataset.fadingElement);
		const itemFading = document.getElementById(el.dataset.readMore);
		if (fadingElement.classList.contains('hide')) {
			element.innerHTML = el.dataset.readMoreText;
			fadingElement.classList.remove('hide');
			itemFading.classList.remove('outset-bottom--l');
		} else {
			fadingElement.classList.add('hide');
			element.innerHTML = el.dataset.readLessText;
			itemFading.classList.add('outset-bottom--l');
		}
	}
}
